<template>
    <div style="font-weight: bold;font-size: 20px;text-align: center;padding-top: 50px;background-color: white">
        <v-form>
            <div>CHÀO MỪNG BẠN ĐẾN VỚI
                <div class="primaryColor" style="display: inline">YOCLASS!</div>
            </div>
            <div>HÃY TRẢI NGHIỆM LỚP HỌC TRỰC TUYẾN NGAY HÔM NAY</div>
            <div style="width: 50%;margin:80px auto;min-width: 400px; display: flex;">
                <v-text-field type="text" :label="$t('lang.class.classCode')+' bạn muốn tham gia'"
                              v-model.trim="classCode"
                              name="classCode" v-validate="'required'" maxLength="20" autofocus
                              :error-messages="errors.first('classCode')" solo
                              :data-vv-as="$t('lang.class.classCode')"
                ></v-text-field>
                <v-btn class="yoprimary" dark @click="joinClass">
                    {{$t('lang.class.joinClass')}}
                </v-btn>
            </div>
            <div class="hotClass" style="padding: 10px 20px; margin:80px auto;width: 50%" >
                <div>KHÁM PHÁ THÊM CÁC LỚP ĐƯỢC YÊU THÍCH TRÊN YOCLASS</div>
                <a v-for="cl in topClasses" style="width: 200px">
                    <img class="classCover" :src="cl.url"/>
                    <h3>{{cl.name}}</h3>
                    <div>{{cl.teacher}}</div>
                </a>
            </div>
        </v-form>

    </div>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";
    import {CrudService} from "@/services";

    export default {
        name: "student-info",
        components: {
            IUpload,
            IDatepicker,
        },

        data() {
            return {
                classCode: "",
                topClasses: [
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1550821579.jpg',
                        name: 'Bài 3: Giải bài toán bằng cách lập hệ phương trình (phần 1)',
                        teacher: 'DƯƠNG ANH'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1550723577.jpg',
                        name: 'Bài 1: Kim loại kiềm và hợp chất của kim loại kiềm',
                        teacher: 'Mai Nguyễn'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1550723683.jpg',
                        name: 'Bài 3: Giải bài toán bằng cách lập hệ phương trình (phần 1)',
                        teacher: 'MAI TRANG'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/5ba6228b387fe.jpg',
                        name: 'Bài 1: Kim loại kiềm và hợp chất của kim loại kiềm',
                        teacher: 'HỒNG NHUNG'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1564022487.jpg',
                        name: 'Bài 3: Giải bài toán bằng cách lập hệ phương trình (phần 1)',
                        teacher: 'VƯƠNG QUYỀN'
                    }
                ]

            }
        },

        created() {
            if(this.$store.state.auth.loggedIn) {
                let classCode = this.$route.params.classCode;
                let verify = this.$route.params.verify;

                if (classCode != undefined & classCode != null && classCode != "") {
                    if (verify != undefined & verify != null && verify != "") {
                        this.acceptJoinClass(classCode, verify);
                    }
                }
            } else {
                this.$router.push("/register");
            }

        },

        methods: {
            joinClass: function () {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }

                    axios.post(process.env.VUE_APP_API_URL + "/class/joinClass?classCode=" + this.classCode).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.class.joinSuccess"));
                                this.$router.back();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {

                        }
                    )
                });
            },

            acceptJoinClass: function (classCode, verify) {
                axios.post(process.env.VUE_APP_API_URL + "/class/acceptJoinClass?classCode=" + classCode + "&verify=" + verify).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.class.joinSuccess"));
                            this.$router.push("/HomePage");
                        } else {
                            message.error(this.$t(data.description));
                        }
                    },
                    error => {

                    }
                )
            }

        }
    };
</script>
